import { DatePickerDropdown, Text, VSpacer } from '@/components/DesignSystem';
import { ExportReportDialog } from '@/pages/Reports/ExportReportDialog';
import { Stack } from '@mui/material';
import { BillingReportDefaultStartDate, ReportType } from '@shared/enums';
import { formatLocalDate } from '@shared/utilities';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface BillingExportDialogProps {
  onClose: () => void,
  retailerId: string,
}

/** Local midnight, so the picker opens on the day the string names rather than the one before. */
const toLocalDate = (dateOnly: string) => new Date(`${dateOnly}T00:00:00`);

export const BillingExportDialog = ({ onClose, retailerId }: BillingExportDialogProps) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<Date | undefined>(
    toLocalDate(BillingReportDefaultStartDate),
  );
  const [isStartDateValid, setIsStartDateValid] = useState(true);

  return (
    <ExportReportDialog
      confirmMessage={t($ => $.reports.billing.exportWarning)}
      isConfirmDisabled={!isStartDateValid}
      onClose={onClose}
      request={{
        params: startDate ? { startDate: formatLocalDate(startDate) } : {},
        type: ReportType.Billing,
      }}
      retailerId={retailerId}
      testID="billing-export-confirmation-dialog"
      title={t($ => $.reports.reportType.billing.name)}
    >
      <Stack>
        <DatePickerDropdown
          label={t($ => $.reports.billing.startDate)}
          onChange={setStartDate}
          onValidityChange={setIsStartDateValid}
          testID="billing-start-date"
          value={startDate}
        />
        <VSpacer size="3" />
        <Text category="body-small">{t($ => $.reports.billing.startDateHelp)}</Text>
      </Stack>
    </ExportReportDialog>
  );
};
